import React from 'react'

const Footer = () => {
    return (
        <>
            <nav className="navbar bg-dark pb-3 navbarfooter">
                <span id="footerContent" className="col-12 p-2 text-center mb-2">Gallery App created with React</span>
                <div className="col-12 col-md-8 p-4 loremfooter">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis dolores, et, aliquam consectetur quibusdam pariatur accusamus dignissimos dolore sapiente reiciendis cupiditate in. Ea odio voluptates debitis incidunt reiciendis ipsam id odit aperiam, pariatur eligendi? Aut minima tempora impedit incidunt, sequi aliquid adipisci perspiciatis tempore hic suscipit molestias provident quia natus!</div>
                <div className="col-12 col-md-4 myinfo p-4 text-center d-flex flex-column">
                    <span id="myname">Vicente Ford - &copy; {new Date().getFullYear()}</span>
                    <a href="https://www.linkedin.com/in/vicenteford/" target="_blank" rel="noopener noreferrer"><i class="bi bi-linkedin"></i> My Linkedin</a>
                    <a href="mailto:fordvicente1@gmail.com" target="_blank" rel="noopener noreferrer"><i class="bi bi-envelope-fill"></i> Email me!</a>
                </div>
                
            </nav>
        </>
    )
}

export default Footer
